
import Vue from 'vue'
import { search } from '../store/actions'
import { IFilter } from '../store/state'
import Filters from './Filters.vue'

// Interfaces for component typechecking!
interface SearchData {
	query: string
}

interface SearchMethods {
	search(): void
	toggleFilter(): void
	clearFilters(): void
}

interface SearchComputed {
	filters: IFilter[]
	showFilter: boolean
	selectedFilters: number
}

interface SearchProps {

}

export default Vue.extend<SearchData, SearchMethods, SearchComputed, SearchProps>({
	name: 'Search',
	data: {
		query: ''
	},
	computed: {
		filters() {
			return this.$store.state.filters
		},
		showFilter() {
			return this.$store.state.showFilter
		},
		selectedFilters() {
			return this.$store.getters.selectedFilters.length
		}
	},
	mounted() {
			const search = this.$refs.search as HTMLElement;
			const searchHeight = search ? search.clientHeight / 2 : 0;
			search && searchHeight && search.setAttribute("style", `margin-top:-${searchHeight}px`);
	},
	methods: {
		search() {
			this.$store.dispatch(search(this.query))
		},
		toggleFilter() {
			this.$store.commit({
				type: 'toggleFilter',
				payload: undefined
			})
		},
		clearFilters() {
			this.$store.commit({
				type: 'clearFilters',
				payload: undefined
			})
		},
	},
	components: {
		Filters
	}
})
